import { clientGet } from 'data/clients/axios-api.client';
import { IUserProfile } from 'data/entities/userprofile.entity';

interface IUserProfileDatasource {
    getUserProfile(): Promise<IUserProfile | null>;
}
class UserProfileDatasource implements IUserProfileDatasource {
    public async getUserProfile(): Promise<IUserProfile | null> {
        const url = `${process.env.REACT_APP_WEBAPI_URL}/userprofile`;
        const result = await clientGet<IUserProfile>(url);
        return result.data;
    }
}
export const userProfileDatasource: IUserProfileDatasource = new UserProfileDatasource();
